/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ResetStagingJiraRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {ResetStagingJiraResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const resetStagingJira = (request: ResetStagingJiraRequest, options?: CashRequestOptions) => post<ResetStagingJiraRequest, ResetStagingJiraResponse>("/2.0/cash/reset-staging-jira", request, {...options, rejectOnError: true })